import {useState} from "react";
import './ClaimSelector.scss';
import {Utils} from "../Utils";
import { ClaimStatusLabel } from './ClaimStatusText';

const Claim = function ({ claim, selected, onSelectClaim }) {
    const handleClick = (e) => {
        onSelectClaim?.(claim._id, e)
    };

    let etprice = claim.etprice ? ("סכום התביעה " + claim.etprice + " ש\"ח") : "";
    let paidTotal = claim.paidTotal ? ("שולמו בפועל " + claim.paidTotal + " ש\"ח") : "";
    let eventDate = Utils.formatDate(Utils.dateStringToObj(claim?.eventDate));

    return (
        <div key={"c" + claim._id} className={"claim" + (selected ? " selected" : "")} onClick={handleClick}>
            <div className="header">
                <img className="selector" src={"img/circle-selector-" + (selected ? "full" : "empty") + ".svg"} alt="" />
                <ClaimStatusLabel claim={claim} />
                <div className="details">{etprice}</div>
                <div className="details">{paidTotal}</div>
                <div className="desc">{claim.eventDescription}</div>
                <div className="detailsTable">
                    <div>
                        <div className="key">קוד תביעה</div>
                        <div className="val">{claim.claimId || "טרם הוגדר"}</div>
                    </div>
                    <div>
                        <div className="key">תאריך האירוע</div>
                        <div className="val">{eventDate}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const ClaimSelector = function ({ claims, onClaimSelected }) {
    const [stateSelectedClaim, setStateSelectedClaim] = useState(-1);

    const handleSelectClaim = (claimId, e) => {
        setStateSelectedClaim(claimId);
        onClaimSelected?.(claimId,e);
    }

    return (
        <div className="claim-container">
            {
                claims?.map(v => Claim({
                    claim: v,
                    selected: v._id === stateSelectedClaim,
                    onSelectClaim: handleSelectClaim
                }))
            }
        </div>
    )
}

export { ClaimSelector }